module.exports = __webpack_public_path__ + "static/media/me.982d902f.gif";